import { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import { HomepageSlice } from '@adapters/prismic/types/homepage';
import { PageType } from '@adapters/prismic/types/slices';
import { AlgonomyPlacement } from '@components/product/ProductCollectionComponent';
import type { HitProps } from '@components/algolia/Hit';

import styles from './LandingPageSliceZone.module.scss';

const LandingPageSliceHandler = dynamic(
  () => import('./LandingPageSliceHandler')
);

export interface HomepageSliceZoneProps {
  slices: HomepageSlice[];
  pageType: PageType;
  recommendations: AlgonomyPlacement[] | null;
  recommendationsCategory?: string | null;
  /** ED-345: SKU->product data resolved in getStaticProps for image_hotspot slices. */
  imageHotspotProducts?: Record<string, HitProps>;
}

const LandingPageSliceZone = ({
  slices,
  pageType,
  recommendations,
  recommendationsCategory,
  imageHotspotProducts,
}: HomepageSliceZoneProps): ReactElement => (
  <div>
    {slices?.map((slice, i) => (
      <section
        className={styles.landingPageSlice}
        key={`landingpage-slice-${i}`}
      >
        <LandingPageSliceHandler
          slice={slice}
          pageType={pageType}
          sliceIndex={i}
          recommendations={recommendations}
          recommendationsCategory={recommendationsCategory}
          imageHotspotProducts={imageHotspotProducts}
        />
      </section>
    ))}
  </div>
);

export default LandingPageSliceZone;
